module.exports = __webpack_public_path__ + "static/media/Aura_device.c63fe52c.png";